import { StacksProvider } from '@stacks/connect';

import { getStorageKeysForNetwork } from '../utils/LocalstorageUtils';
import { resolveProvider } from '../utils/provider';

import { PROVIDERS } from './useData';

type WalletProviderType = {
  provider: PROVIDERS;
  stacksProvider: StacksProvider;
};

export const useWalletProvider = (): WalletProviderType | null => {
  const storedProvider = localStorage.getItem(getStorageKeysForNetwork().walletType);
  if (!storedProvider) return null;

  return {
    provider: storedProvider as PROVIDERS,
    stacksProvider: resolveProvider(storedProvider as PROVIDERS),
  };
};
